// third-party
import { FormattedMessage } from 'react-intl';

// assets
import ImportContactsIcon from '@mui/icons-material/ImportContacts';

const icons = {
    ImportContactsIcon
};

const addressBook = {
    id: 'addressBook',
    type: 'group',
    children: [
        {
            id: 'addressbook',
            title: 'Address Book',
            type: 'item',
            url: '/address-book',
            icon: icons.ImportContactsIcon,
            breadcrumbs: false
        }
    ]
};

export default addressBook;
